import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./OnBoardingReminders.css";
import { useOnboarding } from "../contexts/OnboardingContext";
import api from "../../../axiosconfig.js";
import { toast } from "react-toastify";

export const OnBoardingReminders = () => {
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { onboardingData } = useOnboarding();

  const setReminder = async (type) => {
    if (isSubmitting) return;

    const { email } = onboardingData;
    let DailyReminderMessage = "Hi, login today.";
    let AssesmentReminder = "NONE";

    if (type === "Daily") {
      AssesmentReminder = "Days/1";
    } else if (type === "Weekly") {
      AssesmentReminder = "Days/7";
    }

    const AssesmentReminderMessage =
      "Hello, this is your weekly reminder to login and complete your PEARLI assesment";
    const DailyReminder = "08:00";
    const AssesmentZeroDay = new Date().toDateString();
    const emailToggle = true;

    setIsSubmitting(true);
    try {
      const response = await api.post("/reminders", {
        request: "setReminder",
        email,
        DailyReminderMessage,
        AssesmentReminder,
        AssesmentReminderMessage,
        DailyReminder,
        AssesmentZeroDay,
        emailToggle,
      });

      if (response.data?.result) {
        toast.success(`${type} reminders configured!`);
        navigate("/Home");
      } else {
        console.error("Failed to set reminder");
        toast.error("Failed to set reminder. Proceeding to home.");
        navigate("/Home");
      }
    } catch (err) {
      console.error("Error sending data", err);
      toast.error("There was an error saving your reminder settings.");
      navigate("/Home");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleSkip = () => {
    navigate("/Home");
  };

  return (
    <div className="onboarding-reminders-page-wrapper">
      {/* Top Navigation / Glassmorphic Back button */}
      <button
        type="button"
        className="onboarding-reminders-back-btn"
        onClick={() => navigate(-1)}
        aria-label="Go Back"
      >
        <span className="onboarding-reminders-back-arrow" aria-hidden="true">
          &larr;
        </span>
        <span className="onboarding-reminders-back-label">Back</span>
      </button>

      {/* Centered Main Form Card Container */}
      <div className="onboarding-reminders-main-card">
        {/* Title Header */}
        <div className="onboarding-reminders-heading-group">
          <h1 className="onboarding-reminders-page-title">
            What kind of reminders would you like?
          </h1>
          <p className="onboarding-reminders-page-subtitle">
            Select how frequently you'd like to receive well-being reminders.
          </p>
        </div>

        {/* Reminder Choice Cards */}
        <div className="onboarding-reminders-list">
          <button
            type="button"
            className="onboarding-reminders-card"
            onClick={() => setReminder("Weekly")}
            disabled={isSubmitting}
          >
            <div className="onboarding-reminders-card-content">
              <span className="onboarding-reminders-card-title">
                📅 Weekly Reminders
              </span>
              <span className="onboarding-reminders-card-desc">
                Receive weekly check-ins and holistic guidance every Monday.
              </span>
            </div>
            <span className="onboarding-reminders-card-arrow">&rarr;</span>
          </button>

          <button
            type="button"
            className="onboarding-reminders-card"
            onClick={() => setReminder("Daily")}
            disabled={isSubmitting}
          >
            <div className="onboarding-reminders-card-content">
              <span className="onboarding-reminders-card-title">
                ☀️ Daily Reminders
              </span>
              <span className="onboarding-reminders-card-desc">
                Get a gentle daily nudge to stay consistent with your focus.
              </span>
            </div>
            <span className="onboarding-reminders-card-arrow">&rarr;</span>
          </button>

          <button
            type="button"
            className="onboarding-reminders-card disabled"
            disabled
          >
            <div className="onboarding-reminders-card-content">
              <span className="onboarding-reminders-card-title">
                ⚙️ Customised Reminders
              </span>
              <span className="onboarding-reminders-card-desc">
                Set personalized days, times, and notification channels.
              </span>
            </div>
            <span className="onboarding-reminders-badge">Coming Soon</span>
          </button>
        </div>

        {/* Skip Secondary Action */}
        <button
          type="button"
          className="onboarding-reminders-skip-btn"
          onClick={handleSkip}
          disabled={isSubmitting}
        >
          Skip for now
        </button>
      </div>
    </div>
  );
};

export default OnBoardingReminders;
